import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

import {DeviceType} from '@/model/network/device/DeviceType';
import {DeviceState} from '@/model/network/device/DeviceState';
import {DeviceStatistics} from '@/model/network/device/DeviceStatistics';
import {IpStatus} from '@/model/network/connection/IpStatus';

@jsonObject
export class Device {

  @jsonMember({name: 'id'})
  public Id!: string;

  @jsonMember({name: 'interface'})
  public Interface!: string;

  @jsonMember({name: 'ipInterface'})
  public IpInterface!: string;

  @jsonMember({name: 'state', constructor: String})
  public State!: DeviceState;

  @jsonMember({name: 'ip4Config'})
  public IP4Config!: IpStatus;

  @jsonMember({name: 'dhcp4Config'})
  public DHCP4Config!: any;

  @jsonMember({name: 'ip6Config'})
  public IP6Config!: IpStatus;

  @jsonMember({name: 'dhcp6Config'})
  public DHCP6Config!: any;

  @jsonMember({name: 'managed'})
  public Managed!: boolean;

  @jsonMember({name: 'autoConnect'})
  public AutoConnect!: boolean;

  @jsonMember({name: 'type', constructor: String})
  public Type!: DeviceType;

  @jsonMember({name: 'physicalPortId'})
  public PhysicalPortId!: string;

  @jsonMember({name: 'mtu'})
  public MTU!: number;

  @jsonMember({name: 'connection'})
  public ConnectionId!: string;

  @jsonArrayMember(String, {name: 'profiles'})
  public ProfilesId: string[] = [];

  @jsonMember({name: 'statistics'})
  public Statistics!: DeviceStatistics;
}
